import React, { PropsWithChildren } from "react";

import { Flex, Text } from "@chakra-ui/react";

export const SectionOrderPill: React.FC<
  PropsWithChildren<{ active?: boolean }>
> = ({ active = false, children }) => {
  return (
    <Flex
      rounded="full"
      shrink={0}
      align="center"
      px="4"
      py="2"
      justify="center"
      bgColor={active ? "white" : "transparent"}
    >
      <Text
        fontSize="sm"
        fontWeight="medium"
        flexShrink={0}
        color={active ? "brand" : "white"}
      >
        {children}
      </Text>
    </Flex>
  );
};
